import { render, staticRenderFns } from "./MerchantAccountUpdateStatusModal.vue?vue&type=template&id=2f48a1f9&scoped=true"
import script from "./MerchantAccountUpdateStatusModal.vue?vue&type=script&lang=js"
export * from "./MerchantAccountUpdateStatusModal.vue?vue&type=script&lang=js"
import style0 from "./MerchantAccountUpdateStatusModal.vue?vue&type=style&index=0&id=2f48a1f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f48a1f9",
  null
  
)

export default component.exports